import { useState } from "react";
import { makeStyles, withStyles } from "@mui/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";

const SectionAccordionSummary = withStyles({
  root: {
    borderBottom: "1px solid #aaa",
    flexDirection: "row-reverse",
    paddingLeft: 0,
    minHeight: 48,
    "&$expanded": {
      minHeight: 48,
    },
  },
  content: {
    "&$expanded": {
      marginTop: 0,
      marginBottom: 0,
    },
    paddingLeft: "0.5rem",
    marginTop: 0,
    marginBottom: 0,
  },
  expanded: {},
})(AccordionSummary);

const SectionAccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
}))(AccordionDetails);

const MyAccordion = withStyles({
  root: {
    boxShadow: "none",
  },
  expanded: {},
})(Accordion);

function SectionAccordion({ children, title, defaultExpanded = false, titleVariant = "overline" }) {
    const [expanded, setExpanded] = useState(defaultExpanded);
  
    return (
        <MyAccordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
          <SectionAccordionSummary 
            expandIcon={<ExpandMoreIcon 
                          style={{
                            transform: expanded ? "rotate(180deg)" : "rotate(270deg)",
                            transition: "transform 0.2s",
                          }}
                        />}>
            <Typography variant={titleVariant}>{title}</Typography>
          </SectionAccordionSummary>
          <SectionAccordionDetails style={{ marginLeft: "2rem", marginRight: "1rem" }}>
            { children }
          </SectionAccordionDetails>
        </MyAccordion>
    );
}

export default SectionAccordion;
